import { useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";

const AxiosInterceptor = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => {
        console.log("Respuesta recibida:", response);
        return response;
      },
      (error) => {
        console.log("Error interceptado:", error);
        if (error.response && error.response.status === 403) {
          console.log("Redirigiendo por error 403...");
          window.location.href = "/";
        }
        if (error.response && error.response.status === 404) {
          console.log(" error 404", error);
          // notification["error"]({
          //   message: "Ingrese un titulo para el mensaje a enviar",
          // });
          // window.location.href = '/';
        }
        if (error.response && error.response.status === 500) {
          notification["error"]({
            message: error.response.message,
          });
          window.location.href = "/";
        } else {
          return Promise.reject(error);
        }
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  return children;
};

export default AxiosInterceptor;
